import styled from '@emotion/styled';
import { colors, sizes } from '@smartsheet/lodestar-core';

export const Container = styled.div`
  position: absolute;
  top: 68px;
  right: ${sizes.small}px;

  background: ${colors.neutralLight40};
  box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.24);
  border-radius: 2px;

  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-x: visible;
`;
